import {localizePath, parseLocalePath} from './locale-path';
import {storeLocale, type LocaleStorageWriter} from './locale-choice';
import {LOCALES, type Locale} from './locales';

export interface LanguageSwitcherOption {
    locale: Locale;
    /** Native language name: the full label, and the tooltip of the compact one. */
    label: string;
    /** Two-letter code for the compact switcher: `EN`, `ES`, `DE`. */
    shortLabel: string;
    flag: string;
    /** Address of this page in the language, or null where the language switches in place (the app). */
    href: string | null;
    current: boolean;
}

export function languageSwitcherOptions(path: string, activeLocale: Locale): LanguageSwitcherOption[] {
    const page = parseLocalePath(path);
    return LOCALES.map(({code, nativeName, flag}) => ({
        locale: code,
        label: nativeName,
        shortLabel: code.toUpperCase(),
        flag,
        href: page ? localizePath(page.basePath, code) : null,
        current: code === activeLocale,
    }));
}

export function chooseLocale(input: {
    from: Locale;
    to: Locale;
    storage: LocaleStorageWriter;
    log: (event: string, option: string) => void;
}): void {
    storeLocale(input.storage, input.to);
    if (input.from !== input.to) input.log('language_switch', `${input.from}_${input.to}`);
}
